import CSS from 'csstype';

import ButtonLink from "~/components/ButtonLink";
import { classNames } from "~/utils/utils";
import MyCheckbox, { IMyCheckbox } from "~/mui/MyCheckbox";

import "./style.less";

interface IMyCheckboxAndLink extends IMyCheckbox {
	linkLabel: string;
	className?: string;
	onLinkClick?: () => void;
	contStyle?: CSS.Properties;
}

export default function MyCheckboxAndLink({
	checked,
	label,
	onChange,
	linkLabel = "",
	className = "",
	onLinkClick = () => {},
	contStyle = {},
}: IMyCheckboxAndLink) {
	return <div className={classNames(["myCheckboxAndLink", className])} style={ contStyle }>
		<MyCheckbox label={label} onChange={onChange} checked={checked} />
		<ButtonLink title={linkLabel} onClick={onLinkClick} />
	</div>;
}
